import { render, staticRenderFns } from "./PlanCapabilities.vue?vue&type=template&id=6c034349&scoped=true"
import script from "./PlanCapabilities.vue?vue&type=script&lang=ts"
export * from "./PlanCapabilities.vue?vue&type=script&lang=ts"
import style0 from "./PlanCapabilities.vue?vue&type=style&index=0&id=6c034349&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c034349",
  null
  
)

export default component.exports